import React from "react";

import BasicNavbar from "./BasicNavbar";
import SiteFooter from "../../components/SiteFooter";

export default function DataSecurityPage() {
  return (
    <div className="dark">
      <div className="bg-background relative flex min-h-screen min-h-dvh w-full flex-col overflow-x-hidden overflow-y-auto scroll-smooth">
        <BasicNavbar />
        <main className="relative z-10 flex w-full flex-1 flex-col items-center pt-[calc(6rem+var(--intl-notice-height,0px))] pb-24">
          <section className="w-full max-w-5xl px-6 sm:px-8">
            <h1 className="text-foreground text-2xl font-semibold tracking-tight sm:text-[32px]">
              数据安全管理规范
            </h1>
            <div className="text-default-500 mt-4 space-y-6 text-sm leading-relaxed sm:text-base">
              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">一、总则</h2>
                <p>上海纽酷信息科技有限公司</p>
                <p>NEW CORE TECH CO., PTE. LTD.（以下统称“纽酷信息”或“我们”）</p>
                <p className="mt-2">高度重视客户数据与信息安全。</p>
                <p className="mt-2">
                  纽酷信息旗下产品 3Chat.ai 是一款面向企业客户（ToB）的 AI 客服 / AI Agent / SaaS 平台。
                </p>
                <p className="mt-2">
                  为保障企业客户及其终端用户的数据安全、隐私权益与业务连续性，我们依据中国及国际通行的数据安全与隐私保护原则，制定并实施本《数据安全管理规范》。
                </p>
                <p className="mt-2">
                  本规范用于向客户、合作伙伴及公众说明 3Chat 在数据安全与隐私保护方面的基本原则、管理措施与责任边界。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">二、适用范围与责任主体</h2>
                <h3 className="mt-1 text-[13px] font-semibold text-foreground sm:text-sm">2.1 公司主体</h3>
                <p className="mt-1">公司名称（中文）：上海纽酷信息科技有限公司</p>
                <p>公司名称（英文）：NEW CORE TECH CO., PTE. LTD.</p>

                <h3 className="mt-3 text-[13px] font-semibold text-foreground sm:text-sm">2.2 产品信息</h3>
                <p className="mt-1">产品名称：3Chat.ai</p>
                <p>产品类型：AI 客服 / AI Agent / SaaS</p>
                <p>服务对象：企业客户（ToB）</p>
                <p className="mt-1">主要服务地区：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>中国大陆</li>
                  <li>海外英文地区（North America / Europe 等）</li>
                </ul>

                <h3 className="mt-3 text-[13px] font-semibold text-foreground sm:text-sm">2.3 适用范围</h3>
                <p className="mt-1">本规范适用于 3Chat.ai 在以下场景中的数据处理活动：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>企业客户及其成员使用 3Chat 过程中产生的数据</li>
                  <li>客户通过 3Chat 接入的多渠道会话与服务数据</li>
                  <li>客户主动上传或配置的知识库、业务规则与系统配置数据</li>
                  <li>系统运行过程中产生的必要日志与安全审计数据</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">三、数据分类与处理原则</h2>
                <h3 className="mt-1 text-[13px] font-semibold text-foreground sm:text-sm">3.1 数据类型说明</h3>
                <p className="mt-1">在提供服务过程中，3Chat 可能依法、合规地处理以下类型的数据：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>企业基础信息（如企业名称、联系人、账号信息）</li>
                  <li>企业成员账号与权限管理信息</li>
                  <li>客户与其终端用户之间的会话内容</li>
                  <li>企业上传的知识库文档、业务配置与流程数据</li>
                  <li>系统运行日志（用于稳定性保障与安全审计）</li>
                </ul>
                <p className="mt-2">
                  3Chat 不主动收集或要求企业客户提供个人敏感信息，包括但不限于身份证号、银行卡信息、生物识别信息等。
                </p>

                <h3 className="mt-3 text-[13px] font-semibold text-foreground sm:text-sm">3.2 数据处理基本原则</h3>
                <p className="mt-1">3Chat 在数据处理过程中遵循以下国际通行原则：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>最小必要原则：仅处理实现产品功能所必需的数据</li>
                  <li>用途限定原则：数据仅用于客户授权的业务场景</li>
                  <li>安全优先原则：通过技术与管理措施保障数据安全</li>
                  <li>可控可审计原则：关键数据操作留痕，可追溯、可审计</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">四、数据存储与基础设施安全</h2>
                <p>
                  3Chat 基于主流云服务商基础设施运行，目前使用阿里云。
                </p>
                <p className="mt-2">主要服务器部署区域包括：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>中国大陆</li>
                  <li>新加坡</li>
                </ul>
                <p className="mt-2">
                  采用 SaaS 多租户架构，对客户数据进行逻辑隔离，确保不同企业之间的数据安全独立。
                </p>
                <p className="mt-2">
                  数据在存储与传输过程中采用行业通行的安全控制与加密措施。
                </p>
                <p className="mt-2">
                  生产环境与非生产环境相互隔离，降低数据误用风险。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">五、访问控制与权限管理</h2>
                <h3 className="mt-1 text-[13px] font-semibold text-foreground sm:text-sm">5.1 客户侧权限管理</h3>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>支持企业账号下成员的角色与权限分级（如管理员、普通成员）</li>
                  <li>企业客户可自行配置成员的访问范围与操作权限</li>
                  <li>涉及关键配置或敏感操作的功能，需具备相应授权方可执行</li>
                </ul>

                <h3 className="mt-3 text-[13px] font-semibold text-foreground sm:text-sm">5.2 内部访问控制</h3>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>纽酷信息内部对客户数据实施严格的访问权限控制</li>
                  <li>非经授权，任何内部人员不得访问客户业务数据</li>
                  <li>在技术支持、问题排查等必要场景下的访问行为，均遵循内部审批与记录机制</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">六、AI 能力与数据使用说明</h2>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>客户在 3Chat.ai 中上传的业务数据与会话内容，默认仅用于该客户自身 AI Agent 的运行与优化</li>
                  <li>3Chat 不会在未经客户授权的情况下，将客户数据用于通用 AI 模型训练或对外共享</li>
                  <li>客户可根据自身业务需要，对 AI 使用范围与策略进行配置或限制</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">七、数据共享与第三方合作</h2>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>3Chat 不会擅自向第三方出售、共享或披露客户数据</li>
                  <li>客户数据原则上不在 3Chat 体系外流转</li>
                  <li>
                    若涉及客户主动配置的第三方系统（如电商平台、通信渠道、CRM 系统等）集成，其数据交互范围由客户自行决定并承担相应责任
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">八、数据保留与删除机制</h2>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>在服务关系存续期间，3Chat 根据服务需要合理保留相关业务数据</li>
                  <li>客户在终止服务或提出合法请求后，可按约定流程申请数据删除或清理</li>
                  <li>数据删除或匿名化处理遵循合理期限及技术可行性原则</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">九、安全事件管理与应急响应</h2>
                <p className="mt-1">3Chat 已建立内部数据安全事件管理与应急响应机制：</p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>持续监控潜在的数据安全风险</li>
                  <li>一旦发生或疑似发生安全事件，将及时启动内部响应流程</li>
                  <li>根据事件影响程度，采取必要的补救与风险控制措施，并与相关客户保持沟通</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">十、持续改进与合规承诺</h2>
                <p className="mt-1">
                  3Chat 持续关注并遵循中国及国际通行的数据安全与隐私保护要求，包括但不限于：
                </p>
                <ul className="mt-1 list-inside list-disc space-y-1">
                  <li>中国《网络安全法》《数据安全法》《个人信息保护法》</li>
                  <li>国际通行的数据保护与隐私保护原则（如 GDPR 核心理念）</li>
                </ul>
                <p className="mt-2">
                  并将根据业务发展与监管环境变化，不断完善数据安全管理体系。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">十一、对外联系方式</h2>
                <p className="mt-1">
                  如对本数据安全管理规范或 3Chat 的数据安全实践有任何疑问，请通过以下方式联系我们：
                </p>
                <p className="mt-2">
                  📧 <span className="font-medium text-foreground">contact@3chatai.cn</span>
                </p>
              </section>
            </div>
          </section>
        </main>
        <SiteFooter />
      </div>
    </div>
  );
}

